export const UI = {
  es: {
    nav: { ecosistema: "Ecosistema", herramientas: "Herramientas", soluciones: "Soluciones", seguridad: "Seguridad", empresa: "Empresa", contacto: "Contacto" },
    header: { cta: "Solicitar demostración", tagline: "Intelligence & Cybersecurity", mainNav: "Navegación principal", langSelector: "Selector de idioma", openMenu: "Abrir menú", closeMenu: "Cerrar menú" },
    skip: "Saltar al contenido",
    common: {
      verCapacidad: "Ver capacidad",
      capacidades: "Capacidades",
      limiteVisible: "Los límites, por delante",
      limiteOperativo: "Los límites, por delante",
      condiciones: "Condiciones de prestación",
      condicionesExtra: "Los servicios se prestan bajo contrato, alcance, autorización y marco legal aplicable.",
      solicitarDemo: "Solicitar demostración",
      hablarConOnix: "Hablar con ONIX",
      contactoLabel: "Contacto",
      anterior: "Anterior",
      siguiente: "Siguiente",
      brandLine: "ONIX · INTELLIGENCE & CYBERSECURITY SYSTEMS",
    },
    footer: {
      links: { aviso: "Aviso legal", privacidad: "Privacidad", cookies: "Cookies", terminos: "Términos de uso", contacto: "Contacto", configurarCookies: "Configurar cookies" },
      rights: "Todos los derechos reservados.",
      legalNav: "Enlaces legales",
    },
    cookies: {
      title: "Cookies",
      text: "Este sitio utiliza únicamente cookies técnicas necesarias para su funcionamiento. Las categorías de analítica y personalización permanecen desactivadas hasta que las consientas expresamente. Puedes cambiar tu decisión en cualquier momento desde «Configurar cookies».",
      accept: "Aceptar",
      reject: "Rechazar",
      configure: "Configurar",
      save: "Guardar preferencias",
      region: "Consentimiento de cookies",
      necessary: { name: "Necesarias", desc: "Seguridad, sesión y preferencias. Siempre activas.", aria: "Cookies necesarias, siempre activas" },
      analytics: { name: "Analíticas", desc: "Uso agregado del sitio. Desactivadas por defecto.", aria: "Cookies analíticas" },
      personalization: { name: "Personalización", desc: "Preferencias no esenciales. Desactivadas por defecto.", aria: "Cookies de personalización" },
    },
    form: {
      nombre: "Nombre y apellidos",
      empresa: "Empresa",
      cargo: "Cargo",
      email: "Email profesional",
      telefono: "Teléfono (opcional)",
      area: "Área de interés",
      areaPlaceholder: "Selecciona un área",
      mensaje: "Mensaje",
      consentPre: "He leído la",
      consentLink: "Política de Privacidad",
      consentPost: "y consiento el tratamiento de mis datos para responder a esta solicitud. *",
      submit: "Enviar solicitud",
      sending: "Enviando…",
      beforeSending: "Antes de enviar",
      disclaimer: "No envíes información clasificada, credenciales, muestras de malware, datos especialmente sensibles ni evidencias a través de este formulario.",
      successTitle: "Solicitud registrada.",
      successText: "Gracias por escribirnos. Tu solicitud ha llegado bien: la revisará una persona del equipo y te responderemos al email indicado con una propuesta de conversación ajustada a tu entorno.",
      errNombre: "Indica tu nombre y apellidos.",
      errEmpresa: "Indica tu empresa u organización.",
      errCargo: "Indica tu cargo.",
      errEmail: "Introduce un email profesional válido.",
      errArea: "Selecciona un área de interés.",
      errMensaje: "Describe tu solicitud (mínimo 10 caracteres).",
      errConsent: "Debes aceptar la Política de Privacidad para enviar la solicitud.",
      errServer: "No se pudo registrar la solicitud. Revisa los datos e inténtalo de nuevo. Si el problema persiste, el servicio puede no estar disponible temporalmente.",
      areaLabels: {},
    },
    home: {
      seoTitle: "ONIX | Intelligence & Cybersecurity Systems",
      seoDesc: "Ecosistema de comunicación segura, analítica, investigación, operaciones de seguridad y evidencia para organizaciones que requieren control y trazabilidad.",
      h1Lines: ["Inteligencia que", "convierte señales", "en decisiones."],
      heroText: "Comunicación segura, analítica, investigación, operaciones de seguridad y evidencia: un único ecosistema pensado para las organizaciones que no pueden permitirse improvisar. Con control, trazabilidad y capacidad real de respuesta.",
      ctaSecondary: "Explorar el ecosistema",
      systemTag: "SISTEMA ONIX · 07 CAPACIDADES",
      s1Label: "Sistema",
      s1Title: "Un sistema integrado. Siete capacidades críticas.",
      s1Text: "Cada capacidad ONIX funciona bien por separado, y mejor en conjunto: identidades, eventos, indicadores, casos y evidencias se conectan mediante interfaces gobernadas. Cada flujo tiene una finalidad y un control de acceso, porque integrar nunca debería significar mover datos sin criterio.",
      s2Label: "Herramientas",
      s2Title: "Siete capacidades. Un mismo criterio de control.",
      s3Label: "Confianza",
      s3Title: "Seguridad verificable, no promesas absolutas.",
      s3Text: "Diseñamos con mínimo privilegio, compartimentación, cifrado y trazabilidad. Y preferimos demostrarlo a prometerlo: las propiedades finales de cada despliegue se validan contigo, versión a versión, mediante pruebas de aceptación.",
      s3Link: "Ver principios de seguridad y gobierno",
      ctaLabel: "Conversemos",
      ctaTitle: "Diseñemos juntos un alcance útil y verificable.",
      ctaText: "Cuéntanos qué te preocupa proteger, analizar o coordinar. Te escuchamos primero y después preparamos una conversación técnica y comercial hecha a la medida de tu entorno.",
    },
    eco: {
      seoTitle: "Ecosistema ONIX | Intelligence & Cybersecurity Systems",
      seoDesc: "Un sistema integrado con siete capacidades críticas: comunicar, observar, analizar, proteger, investigar, evidenciar y dirigir.",
      label: "Ecosistema",
      toolsLabel: "Herramientas y capacidades",
      ctaTitle: "Diseñemos juntos un alcance útil y verificable.",
      ctaText: "Cuéntanos qué te preocupa proteger, analizar o coordinar. Te escuchamos primero y después preparamos una conversación técnica y comercial hecha a la medida de tu entorno.",
    },
    tool: {
      breadcrumb: "Ecosistema",
      breadcrumbAria: "Miga de pan",
      capsLabel: "Qué aporta esta capacidad",
      capsSection: "Capacidades",
      ctaLabel: "Demostración",
      ctaTitle: "Evalúa esta capacidad sobre tu entorno real.",
      ctaText: "Solicita una demostración y prepararemos una sesión técnica y comercial pensada para tu organización, con alcance, controles y límites claros desde el principio.",
    },
    sol: {
      seoTitle: "Soluciones | ONIX",
      seoDesc: "Soluciones ONIX orientadas a problemas de negocio: coordinación segura, operaciones de seguridad, investigación, evidencia, exposición e integraciones controladas.",
      label: "Soluciones",
      h1: "Problemas reales. Capacidades combinadas.",
      intro: "Cada solución combina varias capacidades del ecosistema ONIX y siempre llega con sus controles y sus límites por delante. Trabajamos bajo contrato, alcance, autorización y el marco legal aplicable.",
      reto: "Reto",
      enfoque: "Enfoque ONIX",
      capacidades: "Capacidades",
      controles: "Controles",
      limites: "Límites",
      siguiente: "Siguiente paso",
      ctaRow: "Solicitar una conversación",
    },
    seg: {
      seoTitle: "Seguridad y gobierno | ONIX",
      seoDesc: "Principios de seguridad y gobierno del ecosistema ONIX: autorización, mínimo privilegio, trazabilidad, segregación, validación humana y cadena de custodia.",
      label: "Seguridad y gobierno",
      h1: "Principios que gobiernan cada despliegue.",
      intro: "Doce principios que aplicamos desde el diseño hasta la operación diaria. Cómo se implantan en tu caso concreto se define por alcance y se comprueba con pruebas de aceptación.",
      principlesLabel: "Principios",
      ctaTitle: "Hablemos de controles, no de promesas.",
      ctaText: "Si tu organización necesita ver cómo se aplican estos principios a un caso concreto, prepararemos una conversación técnica con límites claros desde el primer día.",
    },
    emp: {
      seoTitle: "Empresa | ONIX",
      seoDesc: "ONIX desarrolla capacidades de inteligencia y ciberseguridad para organizaciones que requieren operar con discreción, evidencia y criterio. ONIX es una marca de ARÁNDANO PARTNERS, S.L.",
      label: "Empresa",
      h1: "Tecnología con propósito, control y responsabilidad.",
      intro: "Detrás de ONIX hay un equipo que desarrolla y articula capacidades de inteligencia y ciberseguridad para organizaciones que trabajan con discreción, evidencia y criterio. Combinamos producto, arquitectura, implantación e integración, siempre con límites explícitos y validación por alcance.",
      enfoqueLabel: "Enfoque",
      approach: [
        { num: "01", title: "Producto", desc: "Herramientas documentadas con estado, capacidades y límites explícitos." },
        { num: "02", title: "Arquitectura", desc: "Diseño por finalidad, clasificación y control de acceso, con compartimentación." },
        { num: "03", title: "Implantación", desc: "Despliegues por alcance, con pruebas de aceptación y evidencias verificables." },
        { num: "04", title: "Integración", desc: "Interfaces gobernadas entre capacidades ONIX y sistemas del cliente." },
      ],
      opsLabel: "Operaciones",
      opsTitle: "Rigor de laboratorio. Disciplina operativa.",
      opsText: "Diseñamos, probamos y operamos las capacidades ONIX en entornos controlados, con funciones separadas y una regla que no negociamos: antes de cada decisión importante, valida una persona.",
      opsCaption: "Imagen ilustrativa",
      opsAlt1: "Especialistas con uniforme ONIX trabajando en un laboratorio de operaciones de ciberseguridad — imagen ilustrativa",
      opsAlt2: "Especialista con chaqueta ONIX analizando un panel de diagramas en laboratorio — imagen ilustrativa",
      ownershipLabel: "Titularidad",
      ownership: "ONIX es una marca de ARÁNDANO PARTNERS, S.L.",
      ownershipText: "Los servicios se prestan bajo contrato, alcance, autorización y marco legal aplicable. La información publicada en este sitio tiene carácter general y no constituye oferta contractual ni garantía técnica.",
      logoAlt: "Escudo ONIX sobre fondo claro",
      ctaTitle: "Hablemos de tu entorno.",
      ctaText: "Cuéntanos qué necesitas proteger, analizar o coordinar. Te responderemos con una conversación honesta, técnica y ajustada a tu organización.",
    },
    contact: {
      seoTitle: "Contacto | ONIX",
      seoDesc: "Solicita una demostración o una conversación técnica y comercial sobre el ecosistema ONIX.",
      label: "Contacto",
      h1: "Solicitar demostración.",
      intro: "Cuéntanos qué te preocupa proteger, analizar o coordinar. Te escuchamos primero y después preparamos una conversación técnica y comercial hecha a la medida de tu entorno.",
      steps: [
        { num: "01", text: "Leemos tu solicitud con calma y criterio. La revisa una persona del equipo, no un sistema automático." },
        { num: "02", text: "Preparamos una conversación a la medida de tu entorno, sin ningún compromiso por tu parte." },
        { num: "03", text: "Definimos contigo un alcance útil, verificable y con los límites claros desde el principio." },
      ],
    },
    notfound: {
      seoTitle: "Página no encontrada | ONIX",
      seoDesc: "La página solicitada no existe.",
      tag: "ERROR 404",
      h1: "Página no encontrada.",
      text: "Esta página no existe o ya no está aquí. No pasa nada: puedes volver al inicio o explorar el ecosistema ONIX.",
      home: "Volver al inicio",
      eco: "Explorar el ecosistema",
    },
    legal: {
      sectionLabel: "Información legal",
      ownershipLine: "ONIX es una marca de ARÁNDANO PARTNERS, S.L. Titular del sitio: ARÁNDANO PARTNERS, S.L.",
      adminTitle: "Aviso interno · solo visible en desarrollo",
      adminNote: "Los campos marcados corresponden a configuración pendiente y deben completarse antes de la publicación en producción.",
      adminFields: "Campos pendientes:",
      pendingWord: "pendiente",
      pendingTitle: "Campo pendiente de configuración",
      pagesNav: "Páginas legales",
      navLabels: { "aviso-legal": "Aviso legal", privacidad: "Política de privacidad", cookies: "Política de cookies", "terminos-de-uso": "Términos de uso" },
    },
  },

  en: {
    nav: { ecosistema: "Ecosystem", herramientas: "Tools", soluciones: "Solutions", seguridad: "Security", empresa: "Company", contacto: "Contact" },
    header: { cta: "Request a demonstration", tagline: "Intelligence & Cybersecurity", mainNav: "Main navigation", langSelector: "Language selector", openMenu: "Open menu", closeMenu: "Close menu" },
    skip: "Skip to content",
    common: {
      verCapacidad: "View capability",
      capacidades: "Capabilities",
      limiteVisible: "The limits, upfront",
      limiteOperativo: "The limits, upfront",
      condiciones: "Terms of provision",
      condicionesExtra: "Services are provided under contract, scope, authorisation and the applicable legal framework.",
      solicitarDemo: "Request a demonstration",
      hablarConOnix: "Talk to ONIX",
      contactoLabel: "Contact",
      anterior: "Previous",
      siguiente: "Next",
      brandLine: "ONIX · INTELLIGENCE & CYBERSECURITY SYSTEMS",
    },
    footer: {
      links: { aviso: "Legal notice", privacidad: "Privacy", cookies: "Cookies", terminos: "Terms of use", contacto: "Contact", configurarCookies: "Cookie settings" },
      rights: "All rights reserved.",
      legalNav: "Legal links",
    },
    cookies: {
      title: "Cookies",
      text: "This site only uses technical cookies that are strictly necessary for its operation. Analytics and personalisation categories remain disabled until you expressly consent. You can change your decision at any time from “Cookie settings”.",
      accept: "Accept",
      reject: "Reject",
      configure: "Configure",
      save: "Save preferences",
      region: "Cookie consent",
      necessary: { name: "Necessary", desc: "Security, session and preferences. Always active.", aria: "Necessary cookies, always active" },
      analytics: { name: "Analytics", desc: "Aggregated site usage. Disabled by default.", aria: "Analytics cookies" },
      personalization: { name: "Personalisation", desc: "Non-essential preferences. Disabled by default.", aria: "Personalisation cookies" },
    },
    form: {
      nombre: "Full name",
      empresa: "Company",
      cargo: "Role",
      email: "Business email",
      telefono: "Phone (optional)",
      area: "Area of interest",
      areaPlaceholder: "Select an area",
      mensaje: "Message",
      consentPre: "I have read the",
      consentLink: "Privacy Policy",
      consentPost: "and I consent to the processing of my data in order to respond to this request. *",
      submit: "Send request",
      sending: "Sending…",
      beforeSending: "Before sending",
      disclaimer: "Do not send classified information, credentials, malware samples, specially sensitive data or evidence through this form.",
      successTitle: "Request registered.",
      successText: "Thank you for writing to us. Your request has arrived safely: a person on the team will review it and reply to the email provided with a conversation proposal tailored to your environment.",
      errNombre: "Please enter your full name.",
      errEmpresa: "Please enter your company or organisation.",
      errCargo: "Please enter your role.",
      errEmail: "Please enter a valid business email.",
      errArea: "Please select an area of interest.",
      errMensaje: "Please describe your request (minimum 10 characters).",
      errConsent: "You must accept the Privacy Policy to send the request.",
      errServer: "The request could not be registered. Please check the data and try again. If the problem persists, the service may be temporarily unavailable.",
      areaLabels: { "Sensorización y ciberdefensa": "Sensorisation & cyber defence", "Partnership o integración": "Partnership or integration", Otro: "Other" },
    },
    home: {
      seoTitle: "ONIX | Intelligence & Cybersecurity Systems",
      seoDesc: "An ecosystem of secure communication, analytics, investigation, security operations and evidence for organisations that require control and traceability.",
      h1Lines: ["Intelligence that", "turns signals", "into decisions."],
      heroText: "Secure communication, analytics, investigation, security operations and evidence: a single ecosystem built for organisations that cannot afford to improvise. With control, traceability and real response capability.",
      ctaSecondary: "Explore the ecosystem",
      systemTag: "ONIX SYSTEM · 07 CAPABILITIES",
      s1Label: "System",
      s1Title: "One integrated system. Seven critical capabilities.",
      s1Text: "Every ONIX capability works well on its own — and better together: identities, events, indicators, cases and evidence connect through governed interfaces. Every flow has a purpose and an access control, because integration should never mean moving data without judgement.",
      s2Label: "Tools",
      s2Title: "Seven capabilities. One standard of control.",
      s3Label: "Trust",
      s3Title: "Verifiable security, not absolute promises.",
      s3Text: "We design with least privilege, compartmentalisation, encryption and traceability. And we would rather prove it than promise it: the final properties of every deployment are validated with you, version by version, through acceptance tests.",
      s3Link: "View security and governance principles",
      ctaLabel: "Let's talk",
      ctaTitle: "Let's design a useful, verifiable scope together.",
      ctaText: "Tell us what you are trying to protect, analyse or coordinate. We listen first, then prepare a technical and commercial conversation tailored to your environment.",
    },
    eco: {
      seoTitle: "ONIX Ecosystem | Intelligence & Cybersecurity Systems",
      seoDesc: "One integrated system with seven critical capabilities: communicate, observe, analyse, protect, investigate, evidence and direct.",
      label: "Ecosystem",
      toolsLabel: "Tools & capabilities",
      ctaTitle: "Let's design a useful, verifiable scope together.",
      ctaText: "Tell us what you are trying to protect, analyse or coordinate. We listen first, then prepare a technical and commercial conversation tailored to your environment.",
    },
    tool: {
      breadcrumb: "Ecosystem",
      breadcrumbAria: "Breadcrumb",
      capsLabel: "What this capability provides",
      capsSection: "Capabilities",
      ctaLabel: "Demonstration",
      ctaTitle: "Evaluate this capability in your real environment.",
      ctaText: "Request a demonstration and we will prepare a technical and commercial session designed for your organisation, with scope, controls and limits that are clear from the start.",
    },
    sol: {
      seoTitle: "Solutions | ONIX",
      seoDesc: "ONIX solutions oriented to business problems: secure coordination, security operations, investigation, evidence, exposure monitoring and controlled integrations.",
      label: "Solutions",
      h1: "Real problems. Combined capabilities.",
      intro: "Each solution combines several capabilities of the ONIX ecosystem and always arrives with its controls and its limits upfront. We work under contract, scope, authorisation and the applicable legal framework.",
      reto: "Challenge",
      enfoque: "ONIX approach",
      capacidades: "Capabilities",
      controles: "Controls",
      limites: "Limits",
      siguiente: "Next step",
      ctaRow: "Request a conversation",
    },
    seg: {
      seoTitle: "Security & governance | ONIX",
      seoDesc: "Security and governance principles of the ONIX ecosystem: authorisation, least privilege, traceability, segregation, human validation and chain of custody.",
      label: "Security & governance",
      h1: "Principles that govern every deployment.",
      intro: "Twelve principles we apply from design to day-to-day operations. How they are implemented in your specific case is defined per scope and verified through acceptance tests.",
      principlesLabel: "Principles",
      ctaTitle: "Let's talk about controls, not promises.",
      ctaText: "If your organisation needs to see how these principles apply to a specific case, we will prepare a technical conversation with clear limits from day one.",
    },
    emp: {
      seoTitle: "Company | ONIX",
      seoDesc: "ONIX develops intelligence and cybersecurity capabilities for organisations that need to operate with discretion, evidence and judgement. ONIX is a brand of ARÁNDANO PARTNERS, S.L.",
      label: "Company",
      h1: "Technology with purpose, control and responsibility.",
      intro: "Behind ONIX there is a team that develops and orchestrates intelligence and cybersecurity capabilities for organisations that work with discretion, evidence and judgement. We combine product, architecture, deployment and integration, always with explicit limits and validation per scope.",
      enfoqueLabel: "Approach",
      approach: [
        { num: "01", title: "Product", desc: "Documented tools with explicit status, capabilities and limits." },
        { num: "02", title: "Architecture", desc: "Design driven by purpose, classification and access control, with compartmentalisation." },
        { num: "03", title: "Deployment", desc: "Scope-based deployments with acceptance tests and verifiable evidence." },
        { num: "04", title: "Integration", desc: "Governed interfaces between ONIX capabilities and customer systems." },
      ],
      opsLabel: "Operations",
      opsTitle: "Laboratory rigour. Operational discipline.",
      opsText: "We design, test and operate ONIX capabilities in controlled environments, with separated duties and one rule we never negotiate: before every important decision, a person validates.",
      opsCaption: "Illustrative image",
      opsAlt1: "Specialists in ONIX uniforms working in a cybersecurity operations laboratory — illustrative image",
      opsAlt2: "Specialist in an ONIX jacket analysing a diagram panel in a laboratory — illustrative image",
      ownershipLabel: "Ownership",
      ownership: "ONIX is a brand of ARÁNDANO PARTNERS, S.L.",
      ownershipText: "Services are provided under contract, scope, authorisation and the applicable legal framework. The information published on this site is general in nature and does not constitute a contractual offer or a technical guarantee.",
      logoAlt: "ONIX shield on a light background",
      ctaTitle: "Let's talk about your environment.",
      ctaText: "Tell us what you need to protect, analyse or coordinate. We will reply with an honest, technical conversation tailored to your organisation.",
    },
    contact: {
      seoTitle: "Contact | ONIX",
      seoDesc: "Request a demonstration or a technical and commercial conversation about the ONIX ecosystem.",
      label: "Contact",
      h1: "Request a demonstration.",
      intro: "Tell us what you are trying to protect, analyse or coordinate. We listen first, then prepare a technical and commercial conversation tailored to your environment.",
      steps: [
        { num: "01", text: "We read your request carefully and with judgement. A person on the team reviews it, not an automated system." },
        { num: "02", text: "We prepare a conversation tailored to your environment, with no obligation on your side." },
        { num: "03", text: "Together we define a useful, verifiable scope with the limits clear from the start." },
      ],
    },
    notfound: {
      seoTitle: "Page not found | ONIX",
      seoDesc: "The requested page does not exist.",
      tag: "ERROR 404",
      h1: "Page not found.",
      text: "This page doesn't exist or is no longer here. Not to worry: you can head back home or explore the ONIX ecosystem.",
      home: "Back to home",
      eco: "Explore the ecosystem",
    },
    legal: {
      sectionLabel: "Legal information",
      ownershipLine: "ONIX is a brand of ARÁNDANO PARTNERS, S.L. Site owner: ARÁNDANO PARTNERS, S.L.",
      adminTitle: "Internal notice · visible in development only",
      adminNote: "Marked fields correspond to pending configuration and must be completed before publishing to production.",
      adminFields: "Pending fields:",
      pendingWord: "pending",
      pendingTitle: "Field pending configuration",
      pagesNav: "Legal pages",
      navLabels: { "aviso-legal": "Legal notice", privacidad: "Privacy policy", cookies: "Cookie policy", "terminos-de-uso": "Terms of use" },
    },
  },
};
